import { render, staticRenderFns } from "./AlertLinkEntity.vue?vue&type=template&id=79062cfc"
import script from "./AlertLinkEntity.vue?vue&type=script&lang=js"
export * from "./AlertLinkEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports